import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { ScheduleService } from 'src/app/service/schedule.service';
import { DatePipe } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-schedule-preview',
  templateUrl: './schedule-preview.component.html',
  styleUrls: ['./schedule-preview.component.scss']
})
export class SchedulePreviewComponent implements OnInit {
  showLoader: boolean = false;
  scheduleSetupId: any;
  ScheduleHeader:any;
  ScheduleData:any;
  constructor(
    private toastrService: ToastrService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , public scheduleService: ScheduleService
    , private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.scheduleSetupId = params['scheduleId'] || "";

        if (this.scheduleSetupId != "") {
          this.preViewAction();
          this.updateTable()
          this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_SCHEDULE'));
          this.router.navigate(['/schedule/schedule-setup']);
          this.showLoader = false;
        }
      });
  }
  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find(key => object[key] === value);
  }
  preViewAction(){
    let username = this.globals.currentUserInfo.username;
    this.scheduleService.schedulePreviewAction(10,this.scheduleSetupId,"en",username).subscribe(
      data => {
          this.scheduleService.previewEmptySchedule(username).subscribe(
            data => {
              console.log("intial data");
              console.log(data);
              if (data.length > 0) {
                data.shift();
                var indexString = this.getKeyByValue(data[1], "<LAST COLUMN>")?.replace("col", "");
                let maxColumn = 0;
                if (indexString) {
                  maxColumn = parseInt(indexString);
                }

                let newData = data.map((element: any) => {
                  let row: any = {};
                  row.rowdesc = element.rowdesc;
                  for (let i = 1; i < maxColumn; i++) {
                    let indexName = 'col';
                    if (i <= 9) {
                      indexName += "0" + i;
                      // row['col0'+i] =
                    } else {
                      indexName += i;
                      // row['col'+i] =
                    }
                    row[indexName] = element[indexName];

                  }
                  return row;
                });
                //header
                this.ScheduleHeader=newData[0];
                this.ScheduleHeader= Object.values(this.ScheduleHeader);
                //data
                this.ScheduleData = newData.map((element: any) => {
                  return Object.values(element);
                });
                this.ScheduleData.shift();
              // console.log(this.ScheduleData);
              // this.generateBatchStatisticsReportExcel(newData);
              } else {
                this.toastrService.error(this.translate.instant('NOT_FOUND'));
              }
              
            },
            error => {
              //this.showLoader = false;
              this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
            }
          );
        },
  error => {
    //this.showLoader = false;
    this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
  }
);

  }
  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        language: {
          search: "",
         // searchPlaceholder: "Search",
        },
        buttons: [],
      });
    }, 1);
  }

}
